import React, { useState, useEffect } from 'react'
import DialogContent from '@material-ui/core/DialogContent'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import Dialog from 'components/dialog'

const ContactFilterOptionsDialog = ({
  trigger,
  sourceFilterOptions,
  selectedSourceFilters,
  setSelectedSourceFilters,
}) => {
  const [
    pendingSelectedSourceFilters,
    setPendingSelectedSourceFilters,
  ] = useState(selectedSourceFilters)

  useEffect(() => {
    setPendingSelectedSourceFilters(selectedSourceFilters)
  }, [selectedSourceFilters])

  const toggleFilterSelection = filterOption => {
    const currentIndex = pendingSelectedSourceFilters.indexOf(filterOption)
    const newSelection = [...pendingSelectedSourceFilters]

    if (currentIndex === -1) {
      newSelection.push(filterOption)
    } else {
      newSelection.splice(currentIndex, 1)
    }

    setPendingSelectedSourceFilters(newSelection)
  }

  return (
    <Dialog trigger={trigger} maxWidth="xs" fullWidth>
      {({ closeDialog }) => (
        <DialogContent>
          <Box py={1}>
            <Typography variant="subtitle2">Filter contacts</Typography>
            <List>
              {sourceFilterOptions.map(opt => {
                const key = opt.name
                return (
                  <ListItem
                    dense
                    key={key}
                    button
                    onClick={() => toggleFilterSelection(opt)}
                  >
                    <ListItemText id={key} primary={opt.description} />
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="end"
                        onChange={() => toggleFilterSelection(opt)}
                        checked={pendingSelectedSourceFilters.includes(opt)}
                        inputProps={{ 'aria-labelledby': key }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </List>
            <Box display="flex" mt={2}>
              <Box mr={2}>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => {
                    setSelectedSourceFilters(pendingSelectedSourceFilters)
                    closeDialog()
                  }}
                >
                  Apply
                </Button>
              </Box>
              <Button
                size="small"
                onClick={() => {
                  setPendingSelectedSourceFilters(selectedSourceFilters)
                  closeDialog()
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  )
}

export default ContactFilterOptionsDialog
